import { SearchNow } from '../Search/SearchNow'

export const Main = () => {
	return <div>{<SearchNow />}</div>
}
